import React from 'react';

interface GradeBadgeProps {
  grade?: number;
}

export const GradeBadge: React.FC<GradeBadgeProps> = ({ grade }) => {
  const formatGrade = (grade?: number) => {
    if (grade === undefined) return 'N/A';
    return `${Math.round(grade * 100)}%`;
  };

  const getColorClass = (grade?: number) => {
    if (grade === undefined) return '';
    const percent = grade * 100;
    if (percent <= 40) return 'grade-red';
    if (percent <= 60) return 'grade-yellow';
    return 'grade-green';
  };

  return (
    <span className={`user-grade-badge ${getColorClass(grade)}`}>
      {formatGrade(grade)}
    </span>
  );
};
